const SAFE_ESIGN_RETURN_ID = /^[a-zA-Z0-9_-]{1,128}$/

export function isSafeEsignReturnId(value: unknown): value is string {
  if (typeof value !== 'string') return false
  const t = value.trim()
  return t.length > 0 && SAFE_ESIGN_RETURN_ID.test(t)
}

export type TFingerprintingEsignReturnSearch = {
  returnApplicationId?: string
  returnDocumentId?: string
  returnFileId?: string
}

export type TImmigrationEsignReturnSearch = {
  returnCaseId?: string
  returnDocumentId?: string
  returnFileId?: string
}

export function parseFingerprintingEsignReturnSearch(
  search: Record<string, unknown>
): TFingerprintingEsignReturnSearch {
  const raw = search as TFingerprintingEsignReturnSearch
  const out: TFingerprintingEsignReturnSearch = {}
  if (raw.returnApplicationId && isSafeEsignReturnId(raw.returnApplicationId)) {
    out.returnApplicationId = raw.returnApplicationId.trim()
  }
  if (raw.returnDocumentId && isSafeEsignReturnId(raw.returnDocumentId)) {
    out.returnDocumentId = raw.returnDocumentId.trim()
  }
  if (raw.returnFileId && isSafeEsignReturnId(raw.returnFileId)) {
    out.returnFileId = raw.returnFileId.trim()
  }
  return out
}

export function parseImmigrationEsignReturnSearch(
  search: Record<string, unknown>
): TImmigrationEsignReturnSearch {
  const raw = search as TImmigrationEsignReturnSearch
  const out: TImmigrationEsignReturnSearch = {}
  if (raw.returnCaseId && isSafeEsignReturnId(raw.returnCaseId)) {
    out.returnCaseId = raw.returnCaseId.trim()
  }
  if (raw.returnDocumentId && isSafeEsignReturnId(raw.returnDocumentId)) {
    out.returnDocumentId = raw.returnDocumentId.trim()
  }
  if (raw.returnFileId && isSafeEsignReturnId(raw.returnFileId)) {
    out.returnFileId = raw.returnFileId.trim()
  }
  return out
}

export function isCompleteFingerprintingReturn(
  parsed: TFingerprintingEsignReturnSearch
): parsed is Required<TFingerprintingEsignReturnSearch> {
  return Boolean(
    parsed.returnApplicationId && parsed.returnDocumentId && parsed.returnFileId
  )
}

export function isCompleteImmigrationReturn(
  parsed: TImmigrationEsignReturnSearch
): parsed is Required<TImmigrationEsignReturnSearch> {
  return Boolean(parsed.returnCaseId && parsed.returnDocumentId && parsed.returnFileId)
}
